import BaseApi from "@/core/HttpResources/BaseApi";
export default class TipoEvaluacionService {
    
    baseApiPublish = new BaseApi("TipoEvaluacion");

    async getByUserProposalAndEvaluacionType(userId: number, proposalId: number, evaluationTypeId: number): Promise<any> {
        return new Promise<any>((resolve, reject) =>
          this.baseApiPublish.request(
            "GET",
            "GetByUserId/"+userId+"/ProposalId/"+proposalId+"/AndEvaluationType/"+evaluationTypeId,
            null,
            {},
            response => resolve(response.data),
            reject,
            () => {}
          )
        );
    }

    async getAll(): Promise<any> {
      return new Promise<any>((resolve, reject) =>
        this.baseApiPublish.request(
          "GET",
          String(),
          null,
          {},
          response => resolve(response.data),
          reject,
          () => {}
        )
      );
  }
 
}